import { FC } from "react";
import { IconProps } from "./types";

export const SpinnerDots: FC<IconProps> = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 53 52"
    preserveAspectRatio="xMidYMid"
    className={className}
    {...props}
  >
    <g>
      <g id="svg_1">
        <g id="svg_2">
          <circle
            id="svg_3"
            transform="matrix(1.01, 0, 0, 1.01, 0, 0)"
            fillOpacity="0.1"
            fill="#0a0a0a"
            r="4.99999"
            cy="25.58801"
            cx="47.04061"
          />
        </g>
      </g>
      <g id="svg_4">
        <g id="svg_5" transform="rotate(36, 43.5004, 38.1874)">
          <circle
            id="svg_6"
            transform="matrix(1.02, 0, 0, 1.02, 0, 0)"
            fillOpacity="0.2"
            fill="#0a0a0a"
            r="5"
            cy="37.43861"
            cx="42.64743"
          />
        </g>
      </g>
      <g id="svg_7">
        <g id="svg_8" transform="rotate(72, 33.0004, 45.8161)">
          <circle
            id="svg_9"
            transform="matrix(1.03, 0, 0, 1.03, 0, 0)"
            fillOpacity="0.3"
            fill="#0a0a0a"
            r="4.99999"
            cy="44.48163"
            cx="32.0392"
          />
        </g>
      </g>
      <g id="svg_10">
        <g id="svg_11" transform="rotate(108, 20.0216, 45.8161)">
          <circle
            id="svg_12"
            transform="matrix(1.04, 0, 0, 1.04, 0, 0)"
            fillOpacity="0.4"
            fill="#0a0a0a"
            r="4.99999"
            cy="44.05391"
            cx="19.2516"
          />
        </g>
      </g>
      <g id="svg_13">
        <g id="svg_14" transform="rotate(144, 9.52168, 38.1874)">
          <circle
            id="svg_15"
            transform="matrix(1.05, 0, 0, 1.05, 0, 0)"
            fillOpacity="0.5"
            fill="#0a0a0a"
            r="4.99999"
            cy="36.36893"
            cx="9.06825"
          />
        </g>
      </g>
      <g id="svg_16">
        <g id="svg_17" transform="rotate(180, 5.51102, 25.8439)">
          <circle
            id="svg_18"
            transform="matrix(1.06, 0, 0, 1.06, 0, 0)"
            fillOpacity="0.6"
            fill="#0a0a0a"
            r="4.99999"
            cy="24.38103"
            cx="5.19907"
          />
        </g>
      </g>
      <g id="svg_19">
        <g id="svg_20" transform="rotate(216, 9.52166, 13.5004)">
          <circle
            id="svg_21"
            transform="matrix(1.07, 0, 0, 1.07, 0, 0)"
            fillOpacity="0.7"
            fill="#0a0a0a"
            r="4.99999"
            cy="12.6172"
            cx="8.89875"
          />
        </g>
      </g>
      <g id="svg_22">
        <g id="svg_23" transform="rotate(252, 20.0217, 5.8717)">
          <circle
            id="svg_24"
            transform="matrix(1.08, 0, 0, 1.08, 0, 0)"
            fillOpacity="0.8"
            fill="#0a0a0a"
            r="4.99998"
            cy="5.43676"
            cx="18.53858"
          />
        </g>
      </g>
      <g id="svg_25">
        <g id="svg_26" transform="rotate(288, 33.0004, 5.87171)">
          <circle
            id="svg_27"
            transform="matrix(1.09, 0, 0, 1.09, 0, 0)"
            fillOpacity="0.9"
            fill="#0a0a0a"
            r="4.99999"
            cy="5.38688"
            cx="30.27557"
          />
        </g>
      </g>
      <g id="svg_28">
        <g id="svg_29" transform="rotate(324, 43.5003, 13.5004)">
          <circle
            id="svg_30"
            transform="matrix(1.1, 0, 0, 1.1, 0, 0)"
            fill="#0a0a0a"
            r="4.99998"
            cy="12.27309"
            cx="39.5458"
          />
        </g>
      </g>
    </g>
  </svg>
);
